import Vue from "vue";
import { Store } from "vuex";
let installed = false
export function install(vue: typeof Vue, store: Store<any>) {
    if (installed) {
        return
    }
    function hasPerm(perm: string) {
        const hasPerm = store.getters.menuPermissionSet.has(perm)
        return hasPerm
    }

    vue.prototype.$hasPerm = hasPerm
    vue.directive('perm', {
        inserted: function (el, binding) {
            const toCheckPerm = binding.value
            if (!hasPerm(toCheckPerm)) {
                el.style.display = "none"
            }
        }
    })
}

declare module 'vue/types/vue' {
    interface Vue {
        $hasPerm(perm: string): boolean
    }
}
